import React from 'react';

// A single headline metric tile.
const StatCard = ({ label, value, sub, tone }) => (
  <div className={`sp-stat-card ${tone ? `sp-stat-card--${tone}` : ''}`}>
    <div className="sp-stat-value">{value}</div>
    <div className="sp-stat-label">{label}</div>
    {sub != null && <div className="sp-stat-sub">{sub}</div>}
  </div>
);

export default StatCard;
